export enum BreakpointSizes {
  ExtraSmall = 575.98,
  Small = 767.98,
  Medium = 991.98,
  Large = 1199.98,
}
